export const formatTATCountdown = (minutes: number | undefined): string => {
  if (minutes === undefined || minutes === null) return 'N/A';
  
  if (minutes < 0) {
    const absMinutes = Math.abs(minutes);
    const hours = Math.floor(absMinutes / 60);
    const mins = absMinutes % 60;
    return `-${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }
  
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
};

export const getTATColorClass = (tatStatus: string | undefined): string => {
  switch (tatStatus) {
    case 'green':
      return 'text-success';
    case 'yellow':
      return 'text-warning';
    case 'red':
      return 'text-destructive';
    case 'exceeded':
      return 'text-destructive font-bold';
    default:
      return 'text-muted-foreground';
  }
};

export const getTATBadgeVariant = (tatStatus: string | undefined): 'default' | 'success' | 'warning' | 'destructive' => {
  switch (tatStatus) {
    case 'green':
      return 'success';
    case 'yellow':
      return 'warning';
    case 'red':
    case 'exceeded':
      return 'destructive';
    default:
      return 'default';
  }
};

export const getUrgencyFromElapsedMinutes = (minutes: number): 'low' | 'medium' | 'high' | 'critical' => {
  if (minutes < 30) return 'low';
  if (minutes < 60) return 'medium';
  if (minutes < 120) return 'high';
  return 'critical';
};

export const getWorkflowStepLabel = (step: string | undefined): string => {
  const labels: Record<string, string> = {
    'MD': 'Marked for Discharge',
    'DSS': 'Discharge Summary Saved',
    'DSF': 'Discharge Summary Finalized',
    'PC': 'Pharmacy Clearance',
    'BS': 'Bill Saved',
    'BA': 'Bill Approved',
    'PD': 'Physical Discharge'
  };
  return step ? labels[step] || step : 'N/A';
};

export const getElapsedTimeColorClass = (elapsedTime: string): string => {
  // Parse HH:MM:SS format
  const parts = elapsedTime.split(':');
  if (parts.length !== 3) return 'text-muted-foreground';
  
  const hours = parseInt(parts[0]) || 0;
  const minutes = parseInt(parts[1]) || 0;
  const totalMinutes = hours * 60 + minutes;
  
  // Color coding based on time elapsed:
  // Green: 0-30 minutes
  // Yellow: 31-60 minutes
  // Red: >60 minutes
  if (totalMinutes <= 30) {
    return 'text-success';
  } else if (totalMinutes <= 60) {
    return 'text-warning';
  } else {
    return 'text-destructive';
  }
};
